import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { ConditionIcons } from 'components';
import { IconContext } from 'react-icons';
import OvalDisplay from '../OvalDisplay';
import ForecastSpread from 'components/ForecastSpread';
import DropdownSelector from 'components/DropdownSelector';

import { index } from 'd3';
import { RiDropFill, RiDropLine, RiWindyFill } from 'react-icons/ri';
import { FaHouseChimney, FaTemperatureHalf } from 'react-icons/fa6';
import { FaEye } from 'react-icons/fa';
import { WiSprinkle } from 'react-icons/wi';
import WidgetTimeUpdate from './WidgetTimeUpdate';
import WidgetLoadingAnimation from './WidgetLoadingAnimation';
import { ErrorMessage } from './ErrorMessage';
import { useAPIData } from 'hooks/useAPIData';
import { Layout } from 'antd';
import { LayoutSizeContext, UniqueWidgetRefreshContext } from 'App';
import { Button } from 'react-bootstrap';

import { Container } from 'react-bootstrap';
import { getDetailedForecastData } from 'services/weather/weather.service';

export default function DetailedForecast({
  widgetRefresh,
  setWidgetRefresh,
  dimensions,
  containerSizePx,
}) {
  let dataCache;
  let dataCacheDays;
  let dataTime;

  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState();
  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState(
    new Date().toLocaleString('en-us', { weekday: 'long' }),
  );
  const [selectedTime, setSelectedTime] = useState('Morning');
  const [dateTime, setDateTime] = useState(new Date());
  const [error, setError] = useState({ state: false, message: '' });

  const layout = useContext(LayoutSizeContext);
  const containerWidth = Number.isFinite(containerSizePx?.width)
    ? containerSizePx.width
    : layout.widgetWidth * Math.max(1, Number(dimensions?.[0]) || 1);
  const infoArrayGap = containerWidth < 360 ? 4 : containerWidth < 460 ? 6 : 8;

  const FusionData = useAPIData({
    successCallback: () => {
      setFetching(false);
    },
    errorCallback: () => {
      setError({ state: true, message: 'Error fetching data' });
      setFetching(false);
    },
    fetchingCallback: () => {
      setFetching(true);
    },
  });

  useEffect(() => {
    dataCache = null;
    setFetching(true);
  }, [widgetRefresh]);

  const uwf = useContext(UniqueWidgetRefreshContext);
  const ROUTE = 'getDetailedForecastData';
  const LOCATION = Cookies.get('city') + '-' + Cookies.get('state');
  const UNIQUEKEY = LOCATION + '-' + ROUTE;

  useEffect(() => {
    const fetchData = async () => {
      try {
        FusionData.forceGet({
          key: ROUTE,
          apiFunction: getDetailedForecastData,
        }).then((res) => {
          const now = new Date();

          const dayArray = [];

          //build array
          res.data.result.map((day) => {
            if (
              dayArray.filter((x) => parseInt(x.day_of_week) === parseInt(day.day_of_week))
                .length === 0
            ) {
              const order =
                parseInt(day.day_of_week) < now.getDay()
                  ? parseInt(day.day_of_week) + 7
                  : parseInt(day.day_of_week);

              dayArray.push({
                day_of_week: parseInt(day.day_of_week),
                weekday: day.weekday,
                order: order,
              });
            }
          });

          dataCacheDays = dayArray
            .sort((a, b) => {
              return a.order - b.order;
            })
            .map((x) => {
              return x.weekday;
            });

          setDays(dataCacheDays);

          dataCache = [...res.data.result];

          setData(dataCache);
          setFetching(false);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [uwf[UNIQUEKEY]]);

  useEffect(() => {
    (async () => {
      if (dataCache) {
        setData(dataCache);
        setDays(dataCacheDays);
        setFetching(false);
        return;
      }
      FusionData.get({ key: ROUTE, apiFunction: getDetailedForecastData })
        .then((res) => {
          const now = new Date();

          const dayArray = [];
          //build array
          res.data.result.map((day) => {
            if (
              dayArray.filter((x) => parseInt(x.day_of_week) === parseInt(day.day_of_week))
                .length === 0
            ) {
              const order =
                parseInt(day.day_of_week) < now.getDay()
                  ? parseInt(day.day_of_week) + 7
                  : parseInt(day.day_of_week);

              dayArray.push({
                day_of_week: parseInt(day.day_of_week),
                weekday: day.weekday,
                order: order,
              });
            }
          });

          //   "DayArray:",
          //   dayArray.sort((a, b) => {
          //     return a.order - b.order;
          //   })
          // );
          dataCacheDays = dayArray
            .sort((a, b) => {
              return a.order - b.order;
            })
            .map((x) => {
              return x.weekday;
            });

          setDays(dataCacheDays);

          dataCache = [...res.data.result];

          setData(dataCache);
          setFetching(false);
        })
        .catch((err) => {
          setError({ state: true, message: err.message });
        });
    })();
  }, [widgetRefresh]);

  const getSelected = (day, segment) => {
    return data.filter((item) => {
      return (day ? item.weekday === day : true) && (segment ? item.day_segment === segment : true);
    })[0];
  };
  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  if (fetching)
    return <WidgetLoadingAnimation widgetName={'DetailedForecast'} dimensions={dimensions} />;

  if (data && data.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} />
        <div style={{ padding: 15 }}>No data found.</div>
      </div>
    );
  }

  const InfoArray = ({}) => {
    return (
      <div
        className="d-flex flex-nowrap"
        style={{ flex: 1, height: '100%', minWidth: 0, gap: infoArrayGap, overflow: 'hidden' }}
      >
        {getSelected(selectedDay, 'Morning') && (
          <div className="d-flex" style={{ flex: '1 1 0', minWidth: 0 }}>
            <button
              type="button"
              onClick={() => setSelectedTime('Morning')}
              className="w-100 h-100 p-0 border-0 bg-transparent"
              style={{ minWidth: 0, overflow: 'hidden' }}
            >
              <OvalDisplay
                time={'Morning'}
                temp={getSelected(selectedDay, 'Morning').temperature}
                selected={selectedTime === 'Morning'}
                icon={
                  <ConditionIcons
                    conditionId={parseInt(getSelected(selectedDay, 'Morning').icon)}
                    size={layout.widgetWidth}
                  />
                }
              />
            </button>
          </div>
        )}

        {getSelected(selectedDay, 'Afternoon') && (
          <div className="d-flex" style={{ flex: '1 1 0', minWidth: 0 }}>
            <button
              type="button"
              onClick={() => setSelectedTime('Afternoon')}
              className="w-100 h-100 border-0 p-0 bg-transparent"
              style={{ minWidth: 0, overflow: 'hidden' }}
            >
              <OvalDisplay
                time={'Afternoon'}
                temp={getSelected(selectedDay, 'Afternoon').temperature}
                selected={selectedTime === 'Afternoon'}
                icon={
                  <ConditionIcons
                    conditionId={parseInt(getSelected(selectedDay, 'Afternoon').icon)}
                    size={layout.widgetWidth}
                  />
                }
              />
            </button>
          </div>
        )}

        {getSelected(selectedDay, 'Evening') && (
          <div className="d-flex" style={{ flex: '1 1 0', minWidth: 0 }}>
            <button
              type="button"
              onClick={() => setSelectedTime('Evening')}
              className="w-100 h-100 p-0 border-0 bg-transparent"
              style={{ minWidth: 0, overflow: 'hidden' }}
            >
              <OvalDisplay
                time={'Evening'}
                temp={getSelected(selectedDay, 'Evening').temperature}
                selected={selectedTime === 'Evening'}
                icon={
                  <ConditionIcons
                    conditionId={parseInt(getSelected(selectedDay, 'Evening').icon)}
                    size={layout.widgetWidth}
                  />
                }
              />
            </button>
          </div>
        )}

        {getSelected(selectedDay, 'Night') && (
          <div className="d-flex" style={{ flex: '1 1 0', minWidth: 0 }}>
            <button
              type="button"
              onClick={() => setSelectedTime('Night')}
              className="w-100 h-100 p-0 border-0 bg-transparent"
              style={{ minWidth: 0, overflow: 'hidden' }}
            >
              <OvalDisplay
                time={'Night'}
                temp={getSelected(selectedDay, 'Night').temperature}
                selected={selectedTime === 'Night'}
                icon={
                  <ConditionIcons
                    conditionId={parseInt(getSelected(selectedDay, 'Night').icon)}
                    size={layout.widgetWidth}
                  />
                }
              />
            </button>
          </div>
        )}
      </div>
    );
  };

  const InfoArray2 = ({}) => {
    if (getSelected(selectedDay, selectedTime))
      return (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            maxHeight: 200,
          }}
        >
          <div className="row g-2 text-center fw-bold" style={{ fontSize: layout.baseFontSize }}>
            <div className="col-12 col-sm-6">{`${selectedDay} ${selectedTime}`}</div>
            <div className="col-12 col-sm-6">
              {`${getSelected(selectedDay, selectedTime).temperature}°F`}
            </div>
          </div>
          <div className="row align-items-center text-center text-sm-start" style={{ flex: 1 }}>
            <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-center">
              <IconContext.Provider value={{ size: 40 * layout.scaleMult }}>
                <ConditionIcons
                  conditionId={getSelected(selectedDay, selectedTime).icon}
                  size={layout.widgetWidth / 5}
                />
              </IconContext.Provider>
            </div>
            <div
              className="col-12 col-sm-6 d-flex flex-column justify-content-around"
              style={{ fontSize: layout.baseFontSize }}
            >
              <div>{getSelected(selectedDay, selectedTime).precip}</div>
              <div>{getSelected(selectedDay, selectedTime).sky}</div>
              <div>{getSelected(selectedDay, selectedTime).temp}</div>
            </div>
          </div>
        </div>
      );
  };

  if (dimensions[0] == 1 && dimensions[1] == 2) {
    if (data && data.length > 0 && days) {
      return (
        <div className="container-fluid h-100 p-0" style={{ minHeight: 0 }}>
          <WidgetTimeUpdate route={ROUTE} />

          {data.length && (
            <div className="d-flex flex-column h-100 p-2">
              {/* Center content */}
              <div className="mb-2">
                <DropdownSelector
                  options={days}
                  selectedOption={days.indexOf(selectedDay)}
                  setSelected={(index) => setSelectedDay(days[index])}
                  triggerStyle={{ width: '100%' }}
                />

                {/* Info array (Oval displays) */}
                <div className="pt-2">
                  <InfoArray />
                </div>
              </div>

              {/* Bottom content */}
              <div className="d-flex flex-column flex-grow-1 overflow-hidden pt-1 pb-3">
                {/* Day / time info display */}
                <InfoArray2 />

                {getSelected(selectedDay, selectedTime) && (
                  <div className="p-2" style={{ fontSize: layout.baseFontSize }}>
                    <div className="row gx-2 gy-2 mx-0 row-cols-2 row-cols-md-1">
                      <div className="col d-flex align-items-center mt-4">
                        <RiWindyFill size={layout.widgetWidth / 15} className="me-2" />
                        Wind SP: {getSelected(selectedDay, selectedTime).wind_speed}
                        mph
                      </div>

                      <div className="col d-flex align-items-center">
                        <RiDropLine size={layout.widgetWidth / 15} className="me-2" />
                        Humidity: {getSelected(selectedDay, selectedTime).humidity}
                      </div>

                      <div className="col d-flex align-items-center">
                        <FaHouseChimney size={layout.widgetWidth / 15} className="me-2" />
                        Comfort Level: {getSelected(selectedDay, selectedTime).comfort}°F
                      </div>

                      <div className="col d-flex align-items-center">
                        <ConditionIcons
                          conditionId={19}
                          size={layout.widgetWidth / 15}
                          className="me-2"
                        />
                        Precipitation: {getSelected(selectedDay, selectedTime).precip_prob}
                      </div>

                      <div className="col d-flex align-items-center">
                        <FaEye size={layout.widgetWidth / 15} className="me-2" />
                        Visibility: {getSelected(selectedDay, selectedTime).visibility} mi
                      </div>

                      <div className="col d-flex align-items-center">
                        <WiSprinkle size={layout.widgetWidth / 15} className="me-2" />
                        Dew Point: {getSelected(selectedDay, selectedTime).dew_point}°F
                      </div>

                      <div className="col d-flex align-items-center">
                        <FaTemperatureHalf size={layout.widgetWidth / 15} className="me-2" />
                        Temperature: {getSelected(selectedDay, selectedTime).temperature}°F
                      </div>

                      <div className="col d-flex align-items-center">
                        <RiDropFill size={layout.widgetWidth / 15} className="me-2" />
                        Precip. Total:{' '}
                        {getSelected(selectedDay, selectedTime).rainfall === '*'
                          ? '0'
                          : getSelected(selectedDay, selectedTime).rainfall}
                        "
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
  if (dimensions[0] == 1 && dimensions[1] == 1) {
    if (data && data.length > 0 && days) {
      // if (data && days && selectedDay) {
      // if (data && days && selectedDay && selectedTime) {
      return (
        <div className="container-fluid h-100 p-0 overflow-hidden">
          <WidgetTimeUpdate route={ROUTE} />

          <div className="h-75 p-2">
            <DropdownSelector
              options={days}
              selectedOption={days.indexOf(selectedDay)}
              // selectedOption={0}
              setSelected={(index) => setSelectedDay(days[index])}
              triggerStyle={{ width: '100%' }}
            />

            {/* Info array (Oval displays) */}

            <div className="pt-2 h-100">
              <InfoArray />
            </div>
          </div>
        </div>
      );
    }
  }
  if (dimensions[0] == 2 && dimensions[1] == 1) {
    if (data && data.length > 0 && days) {
      // if (data && days && selectedDay) {
      // if (data && days && selectedDay && selectedTime) {
      return (
        <div
          className="container-fluid p-0 overflow-hidden"
          style={{ height: layout.widgetHeight - 40 }}
        >
          <WidgetTimeUpdate route={ROUTE} />

          {data.length && (
            <div className="d-flex flex-column h-100 p-2">
              {/* Center content */}
              <div className="d-flex flex-row h-55 gap-2">
                {/* Selected info */}
                <div className="d-flex flex-column flex-grow-1 w-100 h-100">
                  {/* Drop-down day selector */}
                  <DropdownSelector
                    options={days}
                    selectedOption={days.indexOf(selectedDay)}
                    setSelected={(index) => setSelectedDay(days[index])}
                    triggerStyle={{ width: '100%' }}
                  />

                  {/* Day / time info display */}
                  <div className="pt-2 h-100">
                    <InfoArray2 />
                  </div>
                </div>

                {/* Info array (Oval displays) */}

                <div className="pt-1 h-100">
                  <InfoArray />
                </div>
              </div>

              {/* Bottom content */}
              <div className="d-flex flex-row flex-grow-1 mt-2">
                {getSelected(selectedDay, selectedTime) && (
                  <ForecastSpread
                    header={''}
                    icon={''}
                    data={{
                      'Wind SP': `${getSelected(selectedDay, selectedTime).wind_speed}mph`,

                      Humidity: `${getSelected(selectedDay, selectedTime).humidity}%`,
                      'Comfort Level': `${getSelected(selectedDay, selectedTime).comfort}°F`,
                      Precipitation: `${getSelected(selectedDay, selectedTime).precip_prob}%`,
                      Visibility: `${getSelected(selectedDay, selectedTime).visibility} mi`,
                      'Dew Point': `${getSelected(selectedDay, selectedTime).dew_point}°F`,
                      Temperature: `${getSelected(selectedDay, selectedTime).temperature}°F`,
                      'Precip. Total': `${
                        getSelected(selectedDay, selectedTime).rainfall === '*'
                          ? '0' // put '0' if there is no value in the data
                          : getSelected(selectedDay, selectedTime).rainfall
                      }"`,
                    }}
                    dataIcons={[
                      <ConditionIcons
                        conditionId={6}
                        size={layout.widgetWidth / 15}
                        className="me-2"
                      />,
                      <RiWindyFill size={layout.widgetWidth / 15} className="me-2" />,
                      <RiDropLine size={layout.widgetWidth / 15} className="me-2" />,
                      <FaHouseChimney size={layout.widgetWidth / 15} className="me-2" />,
                      <ConditionIcons
                        conditionId={19}
                        size={layout.widgetWidth / 15}
                        className="me-2"
                      />,
                      <FaEye size={layout.widgetWidth / 15} className="me-2" />,
                      <WiSprinkle size={layout.widgetWidth / 15} className="me-2" />,
                      <FaTemperatureHalf size={layout.widgetWidth / 15} className="me-2" />,
                      <RiDropFill size={layout.widgetWidth / 15} className="me-2" />,
                    ]}
                    style={{
                      width: '100%',
                      height: '100%',
                      flex: 1,
                      minWidth: 0,
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}
